import React, { useState } from 'react'
import Header from '../../Components/Header'
import './NewParty.css'
import { CssBaseline, TextField, ThemeProvider, createTheme } from '@mui/material';
import moment from "moment";
import { create_event } from '../../Api/firebaseAPis';

function NewParty() {
    const [eventName, setEventName] = useState("")
    const [address, setAddress] = useState("")
    const [location, setLocation] = useState("")
    const [startTime, setStartTime] = useState(new Date())
    const [endTime, setEndTime] = useState(new Date())
    const [loading, setLoading] = useState(false)
    const [guests, setGuests] = useState([])  
    const [image, setImage] = useState()
    const [uploadText, setUploadText] = useState("Upload")
    const [currentUser, setCurrentUser] = useState()
    const [date, setDate] = useState(new Date())

    const [latLong, setLatLong] = useState({

    })
    const color = "#white";
    // const theme = createMuiTheme({
    //     palette: {
    //       type: "dark"
    //     }
    //   });

    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        color
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color
                    }
                }
            }
        }
    });
    const customStyles = {
        control: (base, state) => ({
            ...base,
            background: "#0a0a0a",
            text: "#fff",
            font: "#fff",
            color: "#fff",
            // match with the menu
            borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "grey" : "grey",
            // Removes weird border around container
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                // Overwrittes the different states of border
                borderColor: state.isFocused ? "grey" : "grey"

            }
        }),
        menu: base => ({
            ...base,
            background: "#0a0a0a",
            borderRadius: 0,
            // kill the gap
            padding: 10,
            marginTop: 0,
            text: "#EAEAEA",
            font: "#EAEAEA",
            color: "#EAEAEA",
        }),
        menuList: base => ({
            ...base,
            background: "#0a0a0a",
            text: "#fff",
            padding: 0
        })
    };

    const create_party = async(tok) => {
        if (eventName && location && latLong && startTime && endTime) {      
            let combinedDateTime = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), startTime.getHours(), startTime.getMinutes())    
            var startTimeM = moment(startTime, 'hh:mm:ss a');
            var endTimeM = moment(endTime, 'hh:mm:ss a');
            let hrs = endTimeM.diff(startTimeM, 'hours')
            var mins = moment.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss"))).format("mm")
            var unixS = parseInt((startTime.getTime() / 1000).toFixed(0))
            var unixE = parseInt((endTime.getTime() / 1000).toFixed(0))
            var durUnix = unixE - unixS      
            // let duration = (hrs*60+parseInt(mins))/60      
            let duration = durUnix/(60*60)
          
            if(duration <=1){
              alert("Duration can't be less than 2 hrs")
            }else{        
                let invites = {}        
                for(var i in guests){
                  if(guests[i] !== undefined){  
                    try{              
                      invites[guests[i]] = false
                    }catch{
                 
                    }        
                  }
                }                
                let img = {}
                if(image) {
                  img = {
                    uri: image.path,
                    name: image.filename,
                    fileName: image.filename.split(".")[0],
                    type: image.mime,  
                  }
                }  
                let response2 = await create_event({
                  title: eventName, 
                  location: location, 
                  date: combinedDateTime.toISOString(),           
                  token: tok, 
                  author: tok, 
                  startTime: startTime, 
                  endTimeUnix: parseInt((endTime.getTime() / 1000).toFixed(0)),
                  duration: duration, 
                  latlong: latLong,
                  invites: invites,
                  endTime: endTime,
                  authorName: currentUser?.firstname + " "+ currentUser?.lastname          
                }, img)                        
                if (response2.error) {
                  alert(response2.error)
                } else {
                  let post = response2 
                  setDate(new Date())
                  setLocation('')
                  setEventName('')
                  setGuests([])
                  setStartTime(new Date())          
                  setImage(null)          
                  setUploadText("Upload")
                //   navigate here
                }
            }
          } else {
            alert("Please fill the missing fields")
          }
          setLoading(false)
    }
    

    return (
        <div className='new-party'>            
            <div className='create-form-container'>
                <h3 style={{ marginBottom: '10px' }}>New Event</h3>
                <div className='seperator'></div>
                <div className='form-field-container'>
                    <div className='form-field-grid'>
                        <h5>Event Name</h5>
                        <input
                            className='input-field-dark'
                            placeholder='New Event Name*'
                            value={eventName}
                            onChange={(e) => setEventName(e.target.value)}
                        />
                    </div>
                    <div className='form-field-grid'>
                        <h5>Address</h5>
                        <input
                            className='input-field-dark'
                            placeholder='Address of the event Location*'
                            value={location}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </div>
                    <div className='form-field-grid'>
                        <h5>From*</h5>
                        <ThemeProvider theme={theme}>
                            <CssBaseline />
                            <TextField
                                id="date"
                                type="datetime-local"
                                value={startTime}
                                onChange={(e) => {
                                   
                                    setStartTime(e.target.value)
                                }
                                }
                                defaultValue="2004-05-24"
                                sx={{
                                    width: "100%", borderColor: "#0a0a0a", backgroundColor: "#0a0a0a", color: 'white',
                                    svg: 'white',
                                    input: 'white',
                                    label: 'white'
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    color: 'white',
                                }}
                            />
                        </ThemeProvider>
                    </div>
                    <div className='form-field-grid'>
                        <h5>To*</h5>
                        <ThemeProvider theme={theme}>
                            <CssBaseline />
                            <TextField
                                id="date"
                                type="datetime-local"
                                value={endTime}
                                onChange={(e) => {
                                   
                                    setEndTime(e.target.value)
                                }
                                }
                                defaultValue="2004-05-24"
                                sx={{ width: "100%", borderColor: "#0a0a0a", backgroundColor: "#0a0a0a", color: 'white', svg: "#fff" }}
                                InputLabelProps={{
                                    shrink: true,
                                    color: 'white',
                                }}
                            />
                        </ThemeProvider>
                        {/* <input
                        className='input-field-dark'
                        placeholder='End Time*'
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                    /> */}
                    </div>
                    <div className='form-field-grid'>
                        <h5 style={{ marginBottom: 15 }}>Party Flyer*</h5>
                        <a className='upload-button'>Upload</a>
                    </div>
                    <div className='form-field-grid-bottom'>
                        <a className='gradient__submit--button' >Submit</a>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default NewParty